import { render, staticRenderFns } from "./RepliedIcon.vue?vue&type=template&id=4b111820&scoped=true"
import script from "./RepliedIcon.vue?vue&type=script&lang=js"
export * from "./RepliedIcon.vue?vue&type=script&lang=js"
import style0 from "./RepliedIcon.vue?vue&type=style&index=0&id=4b111820&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b111820",
  null
  
)

export default component.exports